export default "__VITE_ASSET__CX2G$4ue__"